/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import auth from '@/auth/service';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // =============================================================================
    // Theme Routes
    // =============================================================================
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/kontakt-stats',
      name: 'contact',
      component: () => import('./views/ContactStatsPage.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/story-stats',
      name: 'story',
      component: () => import('./views/StoryStatsPage.vue'),
      meta: {
        authRequired: true
      }
    },
    // Login page
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

router.beforeEach((to, from, next) => {
  // If auth required, check login. If login fails redirect to login page
  if (to.meta.authRequired) {
    const ret = auth.isAuthenticated(store);
    if (!ret) {
      router.push({ path: '/login', query: { to: to.path } });
    }
  }

  return next();
});

export default router;
